{
  "common.app.name": "Helsinki-Vantaa drop-off",

  "common.yes": "kyllä",
  "common.no": "ei",
  "common.ok": "ok",
  "common.NA": "ei tiedossa",

  "common.system.enabledTitle": "Järjestelmä on käytössä",
  "common.system.enabledDescription": "Pysäköinneistä veloitetaan ajan ja tariffin mukaan.",
  "common.system.enableButtonText": "Ota käyttöön",
  "common.system.disabledTitle": "Järjestelmä on pois käytöstä",
  "common.system.disabledDescription": "Kaikki pysäköinnit ovat maksuttomia.",
  "common.system.disabledReason": "Syy: {reason}",
  "common.system.disableButtonText": "Ota pois käytöstä",
  "common.system.statusCheckErrorToastText": "Järjestelmän tilan tarkistus epäonnistui.",
  "common.system.unknownTitle": "Järjestelmän tila on tuntematon",
  "common.system.unknownDescription": "Virhe tilatiedon haussa. Yritä myöhemmin uudelleen.",
  "common.system.changeStatusModal.title.enable": "Ota järjestelmä käyttöön",
  "common.system.changeStatusForm.title.enable": "Anna syy järjestelmän käyttöönotolle",
  "common.system.changeStatusForm.submit.enable": "Ota käyttöön",
  "common.system.changeStatusForm.success.enable": "Järjestelmä on nyt käytössä.",
  "common.system.changeStatusForm.submit.disable": "Ota pois käytöstä",
  "common.system.changeStatusModal.title.disable": "Ota järjestelmä pois käytöstä",
  "common.system.changeStatusForm.title.disable": "Anna syy järjestelmän käytöstä poistolle",
  "common.system.changeStatusForm.success.disable": "Järjestelmä on nyt pois käytöstä.",
  "common.system.changeStatusForm.label.reason": "Syy",

  "common.text.duration": "Kesto",
  "common.text.email": "Sähköposti",
  "common.text.endTime": "Päättymisaika",
  "common.text.entryLane": "Sisäänajokaista",
  "common.text.exempt": "Maksuton ajoneuvo",
  "common.text.exemptVehicles": "Maksuttomat ajoneuvot",
  "common.text.exitLane": "Poistumiskaista",
  "common.text.hasEnded": "Päättynyt",
  "common.text.licensePlate": "Rekisteritunnus",
  "common.text.parkingEvents": "Pysäköinnit",
  "common.text.paymentStatus": "Maksun tila",
  "common.text.price": "Hinta",
  "common.text.site": "Kohde",
  "common.text.startTime": "Alkamisaika",
  "common.text.timestamp": "Aikaleima",
  "common.text.whitelist": "Maksuttomat ajoneuvot",

  "common.units.hours.short": "h",
  "common.units.minutes.short": "m",
  "common.units.seconds.short": "s",

  "common.buttons.yes": "Kyllä",
  "common.buttons.add": "Lisää",
  "common.buttons.save": "Tallenna",
  "common.buttons.edit": "Muokkaa",
  "common.buttons.next": "Seuraava",
  "common.buttons.complete": "Valmis",
  "common.buttons.cancel": "Peruuta",
  "common.buttons.remove": "Poista",
  "common.buttons.update": "Päivitä",
  "common.buttons.terminate": "Irtisano",
  "common.buttons.back": "Takaisin",

  "common.actions.error": "Tapahtui virhe",
  "common.actions.add.error": "Lisäys epäonnistui",
  "common.actions.update.error": "Päivitys epäonnistui",
  "common.actions.get.error": "Tietojen haku epäonnistui",
  "common.actions.remove.error": "Poisto epäonnistui",
  "common.actions.search": "Hae",

  "common.form.errors.empty": "Kenttä ei voi olla tyhjä.",
  "common.form.errors.licensePlate": "Syötä kelvollinen ajoneuvon rekisteritunnus.",
  "common.form.errors.number": "Kenttään voi syöttää vain lukuja.",
  "common.form.errors.centsOnly": "Pyöristä lähimpään senttiin.",
  "common.form.errors.negative": "Arvo ei voi olla negatiivinen.",

  "common.access.readOnly": "Vain lukuoikeus",

  "common.paymentStatus.free": "Ilmainen pysäköinti",
  "common.paymentStatus.unpaid": "Pysäköinti maksamatta",
  "common.paymentStatus.paid": "Maksettu",
  "common.paymentStatus.invoicing": "Jälkilaskutuksessa",
  "common.paymentStatus.timedOut": "Aikakatkaistu",
  "common.paymentStatus.undefined": "Ei vielä määritelty",
  "common.paymentStatus.unknown": "Tuntematon",

  "dateTimeRangePicker.labels.start": "Alku",
  "dateTimeRangePicker.labels.end": "Loppu",

  "components.selectSearchField.selectedCountText": "{count} valittu",

  "page.userDetails.title": "Käyttäjän tiedot",
  "page.userDetails.userFullName": "Nimi",
  "page.userDetails.role": "Rooli",

  "page.site.status": "Järjestelmän tila",
  "page.site.status.description": "Järjestelmän voi ottaa pois käytöstä häiriötilanteissa.",

  "page.parkingEvents.ongoing": "Käynnissä",
  "page.parkingEvents.ended": "Päättyneet",
  "page.parkingEvents.ongoing.emptyText": "Ei käynnissäolevia pysäköintejä valituilla hakuehdoilla.",
  "page.parkingEvents.ended.emptyText": "Ei päättyneitä pysäköintejä valituilla hakuehdoilla.",

  "page.parkingDetails.title": "Pysäköinnin tiedot",
  "page.parkingDetails.summary": "Yhteenveto",
  "page.parkingDetails.summary.editButton": "Mitätöi maksu",
  "page.parkingDetails.entryCamera": "Sisäänajo",
  "page.parkingDetails.exitCamera": "Poistuminen",
  "page.parkingDetails.noCamera": "Kameran tiedot puuttuvat",
  "page.parkingDetails.id": "Pysäköintitapahtuman tunniste",
  "page.parkingDetails.editFee": "Mitätöi maksu",
  "page.parkingDetails.camera.name": "Kameran nimi",
  "page.parkingDetails.camera.id": "Kameran tunniste",
  "page.parkingDetails.camera.photo": "Kameran kuva",
  "page.parkingDetails.camera.lane": "Kaista",
  "page.parkingDetails.camera.imageMissing": "kuva ei saatavilla",
  "page.parkingDetails.modalEditFee.title": "Mitätöi maksu",
  "page.parkingDetails.formEditFee.label.comment": "Mitätöinnin syy",
  "page.parkingDetails.formEditFee.label.price": "Hinta (€)",
  "page.parkingDetails.formEditFee.label.pricePreview": "Hinta mitätöinnin jälkeen",
  "page.parkingDetails.formEditFee.submit": "Mitätöi",
  "page.parkingDetails.editFee.success": "Pysäköintimaksun päivityspyyntö on lähetetty.",
  "page.parkingDetails.editFee.genericError": "Pysäköintimaksun päivityspyynnön lähettäminen epäonnistui.",

  "page.whitelist.description": "Tarkastele ajoneuvoja, joilta ei peritä pysäköintimaksua.",
  "page.whitelist.description.create": "Voit myös lisätä, muokata ja poistaa maksuttomia ajoneuvoja.",
  "page.whitelist.description.readOnly": "Sinulla ei ole oikeutta maksuttomien ajoneuvojen lisäämiseen, muokkaamiseen tai poistamiseen.",
  "page.whitelist.table.emptyText": "Ei maksuttomia ajoneuvoja valituilla hakuehdoilla.",
  "page.whitelist.table.header.name": "Nimi",
  "page.whitelist.table.header.createdAt": "Lisätty",
  "page.whitelist.form.label.name": "Nimi",
  "page.whitelist.form.label.comment": "Muutoksen syy",
  "page.whitelist.modal.edit.title": "Muokkaa maksutonta ajoneuvoa",
  "page.whitelist.modal.view.title": "Maksuttoman ajoneuvon tiedot",
  "page.whitelist.modal.create.title": "Lisää maksuton ajoneuvo",
  "page.whitelist.form.edit.title": "Muokkaa maksuttoman ajoneuvon nimeä tai poista ajoneuvo. Muutoksen syy tarvitaan molemmissa tapauksissa.",
  "page.whitelist.form.view.title": "Tarkastele maksutonta ajoneuvoa (vain luku).",
  "page.whitelist.form.create.title": "Lisää uusi maksuton ajoneuvo.",
  "page.whitelist.modal.edit.button.submit": "Päivitä",
  "page.whitelist.modal.view.button.submit": "Sulje",
  "page.whitelist.modal.create.button.submit": "Lisää",
  "page.whitelist.modal.delete.success": "Maksuton ajoneuvo {plate} poistettu.",
  "page.whitelist.modal.delete.error": "Maksuttoman ajoneuvon poisto epäonnistui.",
  "page.whitelist.modal.edit.success": "Maksuton ajoneuvo {plate} päivitetty.",
  "page.whitelist.modal.edit.error": "Maksuttoman ajoneuvon päivitys epäonnistui.",
  "page.whitelist.modal.create.success": "Maksuton ajoneuvo lisätty.",
  "page.whitelist.modal.create.error": "Maksuttoman ajoneuvon lisäys epäonnistui.",

  "sortControl.sortingCriteria": "Järjestys",

  "sortDirection.ASC": "Nouseva",
  "sortDirection.DESC": "Laskeva",

  "sort.WHITELIST.NAME": "Nimi",
  "sort.WHITELIST.LICENSE_PLATE": "Rekisteritunnus",
  "sort.WHITELIST.CREATED_AT": "Lisätty",

  "sort.PARKING_EVENTS_ENDED.LICENSE_PLATE": "Rekisteritunnus",
  "sort.PARKING_EVENTS_ENDED.START": "Alkamisaika",
  "sort.PARKING_EVENTS_ENDED.END": "Päättymisaika",
  "sort.PARKING_EVENTS_ENDED.DURATION": "Kesto",
  "sort.PARKING_EVENTS_ENDED.PRICE": "Hinta",
  "sort.PARKING_EVENTS_ENDED.PAYMENT": "Maksun tila",

  "sort.PARKING_EVENTS_ONGOING.LICENSE_PLATE": "Rekisteritunnus",
  "sort.PARKING_EVENTS_ONGOING.ENTRY_LANE": "Sisäänajokaista",
  "sort.PARKING_EVENTS_ONGOING.START": "Alkamisaika",
  "sort.PARKING_EVENTS_ONGOING.DURATION": "Kesto",

  "menu.user.detail": "Omat tiedot",
  "menu.user.logout": "Kirjaudu ulos",
  "menu.user.fi": "Suomeksi",
  "menu.user.en": "In English",
  "menu.user.tooltip.admin": "Admin-käyttäjä",
  "menu.user.tooltip.user": "Tavallinen käyttäjä",

  "appMenu.subtitle": "Pysäköinnin hallinta",
  "appMenuTop.button.menu": "Valikko",
  "appMenuTop.button.closeMenu": "Sulje menu",

  "moovyErrorPage.oops": "Hups!",
  "moovyErrorPage.message": "Pahoittelut, sivua ei voi ladata. Tarkista osoite ja yritä ladata sivu uudestaan.",

  "login.title": "Kirjaudu sisään",
  "login.button.azure": "Microsoft Entra",
  "login.toast.error": "Kirjautuminen epäonnistui.",
  "logout.toast.error": "Uloskirjautuminen epäonnistui.",
  "authentication.error.configuration": "Sovelluksen todennusjärjestelmän asetukset ovat virheelliset eikä kirjautuminen ole mahdollista.",

  "timestampItems.createdAt": "Luotu",
  "timestampItems.updatedAt": "Päivitetty"
}
